import {
    ajaxP,
    ajax,
    request
} from '@/utils/request'

// 购物车列表
export function cartList() {
    return ajax('api/v1/h5/customerCarts');
}

// 加入购物车
export function cartAdd(params) {
    return ajaxP('api/v1/h5/customerCarts', params, true)
}

// 删除购物车
export function cartDel(ids) {
    return request({
        url: `api/v1/h5/customerCarts/list/${ids}`,
        method: 'DELETE'
    }, true)
}

// 更新购物车
export function cartUpdate(id, params) {
    return request({
        url: `api/v1/h5/customerCarts/${id}`,
        method: 'PATCH',
        data: params,
        params: {
            isNomask: true
        }
    })
}

// 订单详情
export function orderInfo(id) {
    return ajax(`api/v1/orders/h5/${id}`)
}

// 改变订单状态
// state配置:cancel 取消 close 确认收货
export function changeOrder(id, state) {
    return ajaxP(`api/v1/orders/h5/${state}`, {
        id: id
    }, true)
}

// 检查订单是否可以更新地址
export function checkUpAddress(id) {
    return ajax(`api/v1/orders/h5/address/right/${id}`);
}

// 更新收货地址
export function updateAddress(params) {
    return ajaxP(`api/v1/orders/h5/address/update`, params, true)
}

// 确认订单
export function saveOrder(params) {
    return ajaxP('api/v1/orders/h5/prepay', params)
}

// 微信支付
export function weixinPay(id) {
    return ajax(`api/v1/pay/vx/confirm/${id}`);
}

// 积分支付
export function integralPay(id) {
    return ajax(`api/v1/pay/${id}`);
}

// 支付成功后推荐商品
export function ordreEndRecommend(params) {
    return ajax('api/v1/goods/afterPayRecommended', params)
}